import { ACCESS_ROUTES } from '@vizit/access';

export const WORKSPACE_LINK_SEARCH_PARAM = 'workspace';

export const ORGANIZATIONS_ROUTE = '/organizations';

export const WORKSPACE_SUBPATH = {
  integrations: '/settings/integrations',
  userManagement: '/org-user-management',
} as const;

export function workspaceRoute(workspaceSlug: string, subpath = '/'): string {
  const shell = ACCESS_ROUTES.workspaceShell(workspaceSlug);

  if (subpath === '/') {
    return shell;
  }

  const normalized = subpath.startsWith('/') ? subpath : `/${subpath}`;
  return `${shell}${normalized}`;
}
